const storeMutations = {
    // PAYMENT MUTATIONS
    UPDATE_CCTOKEN: "updateCCToken",
    UPDATE_PAYPAL_TOKEN: "updatePaypalToken",
    UPDATE_NEXTGEN_SETTLED_AMOUNT: "updateNextGenSettledAmount",

    // VEHICLE MUTATIONS
    UPDATE_YEAR: "updateYear",
    UPDATE_MAKE: "updateMake",
    UPDATE_MODEL: "updateModel",
    UPDATE_STYLE: "updateStyle",
    UPDATE_VEHICLE_SUBTYPE: "updateVehicleSubType",
    UPDATE_VEHICLE_SPECIAL_CLASS: "updateVehicleSpecialClass",
    UPDATE_IS_BIGTRUCK: "updateIsBigTruck",
    UPDATE_CAR_ID: "updateCarId",
    UPDATE_VEHICLE_CATEGORY: "updateVehicleCategory",
    UPDATE_VEHICLE_IMAGE_URL: "updateVehicleImageUrl",
    UPDATE_VEHICLE_IMAGE_VIF_NUMBER: "updateVehicleImageVifNumber",
    UPDATE_VEHICLE_IMAGE_COLOR: "updateVehicleImageColor",
    UPDATE_VEHICLE_VIN: "updateVehicleVin",
    UPDATE_VEHICLE: "updateVehicle",
    UPDATE_VEHICLE_CAN_SAFELITE_SERVICE: "updateVehicleCanSafeliteService",

    UPDATE_IS_REPAIR: "updateIsRepair",
    UPDATE_NUMBER_OF_CHIPS: "updateNumberOfChips",
    UPDATE_GLASS_TO_REPLACE: "updateGlassToReplace",
    UPDATE_PART_QUESTION_ANSWERS: "updatePartQuestionAnswers",
    UPDATE_MOLDING_QUESTION_ANSWERS: "updateMoldingQuestionAnswers",
    UPDATE_CAPABILITY_QUESTION_ANSWERS: "updateCapabilityQuestionAnswers",
    UPDATE_GLASS_PARTS: "updateGlassParts",
    UPDATE_VAPS: "updateVaps",
    UPDATE_SUPPORTING_ITEMS: "updateSupportingItems",
    UPDATE_LINE_ITEMS_SERVER_DATA: "updateLineItemsServerData",
    UPDATE_INACTIVE_PROMOS: "updateInactivePromos",
    UPDATE_PROMOS: "updatePromos",

    UPDATE_REGISTRATION: "updateRegistration",

    UPDATE_SERVICE_ZIP: "updateServiceZip",
    UPDATE_SERVICE_LOCATION: "updateServiceLocation",
    UPDATE_SERVICE_LOCATION_TECH_NOTES: "updateServiceLocationTechNotes",
    UPDATE_SCHEDULE: "updateSchedule",

    // CUSTOMER MUTATIONS
    UPDATE_CUSTOMER_EMAIL_ADDRESS: "updateCustomerEmailAddress",
    UPDATE_CUSTOMER_PHONE_NUMBER: "updateCustomerPhoneNumber",
    UPDATE_CUSTOMER_IS_SMS_OPT_IN: "updateCustomerIsSmsOptin",
    UPDATE_CUSTOMER_DETAILS: "updateCustomerDetails",
    UPDATE_CUSTOMER_WAITLIST_REQUESTED: "updateCustomerWaitListRequested",

    // ORDER MUTATIONS
    UPDATE_REFERRAL_NUMBER: "updateReferralNumber",
    UPDATE_REFERRAL_SEQUENCE_NUMBER: "updateReferralSequenceNumber",
    UPDATE_REFERRAL_DATE: "updateReferralDate",
    UPDATE_REFERRAL_CORRELATION_ID: "updateReferralCorrelationId",
    UPDATE_PARENT_ACCT_NUMBER: "updateParentAcctNumber",
    UPDATE_BILL_TO_ACCT_NUMBER: "updateBillToAcctNumber",
    UPDATE_EON: "updateEON",
    UPDATE_IS_INSURANCE: "updateIsInsurance",
    UPDATE_IS_VERIFIED_INSURANCE: "updateInsuranceVerifiedStatus",
    UPDATE_SAVED_SESSION_ID: "updateSavedSessionId",
    UPDATE_CRM_CUSTOMER_ID: "updateCrmCustomerId",
    UPDATE_IS_PIA: "updateIsPia",
    UPDATE_PIA_TYPE: "updatePiaType",
    WORK_ORDER_NUMBER: "updateWorkOrderNumber",
    WORK_ORDER_ID: "updateWorkOrderId",
    Customer_Portal_Login_Token: "updateCustomerPortalLoginToken",
    LOCK_TOKEN: "updateLockToken",
    UPDATE_SETTLED_TENDER_AMOUNT: "updateSettledTenderAmount",
    UPDATE_IS_RECAL_ACK_OPT_IN: "updateIsRecalAckOptIn",
    UPDATE_IS_MSR_FEE_APPLICABLE: "updateIsMSRFeeApplicable",
    UPDATE_CASH_PRICE_SUBTOTAL: "updateCashPriceSubTotal",

    // EVENT BUS MUTATIONS
    ADD_EVENT_TO_BUS: "addEventToBus",
    REMOVE_EVENT_FROM_BUS: "removeEventFromBus",

    // DEPENDENCY MUTATIONS
    RESET_VEHICLE_STATE: "resetVehicleState",
    RESET_DAMAGE_STATE: "resetDamageState",
    RESET_REGISTRATION_STATE: "resetRegistrationState",
    RESET_GLASS_PARTS_STATE: "resetGlassPartsState",
    RESET_STATE: "resetState",
    RESET_SAVE_SESSION_PROMISE: "resetSaveSessionPromise",
    RESET_SERVICE_LOCATION_APPOINTMENT_TYPE: "resetServiceLocationAppointmentType",
    RESET_SERVICE_LOCATION_PROVIDER: "resetServiceLocationProvider",
    RESET_SERVICE_LOCATION_MOBILE_ADDRESS: "resetServiceLocationMobileAddress",
    RESET_SCHEDULE: "resetSchedule",
    RESET_PAYMENT_METHOD_CHOICE: "resetPaymentMethodChoice",

    // OTHER MUTATIONS
    UPDATE_PAGE_DATA: "updatePageData",
    UPDATE_STATE_WITH_ORDER_INFORMATION: "updateStateWithOrderInformation",
    UPDATE_SAVE_SESSION_PROMISE: "updateSaveSessionPromise",
    UPDATE_LAST_PAGE_VISITED: "updateLastPageVisited",
    UPDATE_LOGGING_OPTION: "updateLoggingOption",
    UPDATE_HAS_TRIGGERED_ERROR: "updateHasTriggeredError",

    // EXPERIMENT MUTATIONS
    UPDATE_EXPERIMENTS: "updateExperiments",
    UPDATE_TRIGGERED_SITE_ENTRY: "updateTriggeredSiteEntry",

    // EXTERNAL_PARAMETER MUTATIONS
    UPDATE_IS_EXTERNAL_PARAMETER: "updateIsExternalParameter",
    UPDATE_EXTERNAL_PARAMETER_YEAR: "updateExternalParameterYear",
    UPDATE_EXTERNAL_PARAMETER_MAKE: "updateExternalParameterMake",
    UPDATE_EXTERNAL_PARAMETER_MODEL: "updateExternalParameterModel",
    UPDATE_EXTERNAL_PARAMETER_STYLE: "updateExternalParameterStyle",
    UPDATE_EXTERNAL_PARAMETER_IS_REPAIR: "updateExternalParameterIsRepair",
    UPDATE_EXTERNAL_PARAMETER_NUMBER_OF_CHIPS: "updateExternalParameterNumberOfChips",
    UPDATE_EXTERNAL_PARAMETER_DAMAGE_TYPE: "updateExternalParameterDamageType",
    UPDATE_EXTERNAL_PARAMETER_ZIP_CODE: "updateExternalParameterZipCode",
    UPDATE_EXTERNAL_PARAMETER_EMAIL_ADDRESS: "updateExternalParameterEmailAddress",
    UPDATE_EXTERNAL_PARAMETER_IS_INSURANCE: "updateExternalParameterIsInsurance",
    UPDATE_EXTERNAL_PARAMETER_VIN_SELECTION: "updateExternalParameterVinSelection",
    UPDATE_EXTERNAL_PARAMETER_SERVICE_PACKAGE: "updateExternalParameterServicePackage",
    UPDATE_EXTERNAL_PARAMETER_SOURCE: "updateExternalParameterSource",
    UPDATE_EXTERNAL_PARAMETER_PHONE_NUMBER: "updateExternalParameterPhoneNumber",

    //RESET EXTERNAL_PARAMETER MUTATIONS
    RESET_EXTERNAL_PARAMETER_VEHICLE_STATE: "resetExternalParameterVehicleState",
    RESET_EXTERNAL_PARAMETER_DAMAGE_STATE: "resetExternalParameterDamageState",
    RESET_EXTERNAL_PARAMETER_ESTIMATE_STATE: "resetExternalParameterEstimateState",
    RESET_EXTERNAL_PARAMETER_SERVICEZIP_STATE: "resetExternalParameterServiceZipState",
    RESET_EXTERNAL_PARAMETER_QUOTE_STATE: "resetExternalParameterQuoteState",
    RESET_EXTERNAL_PARAMETER_SOURCE_STATE: "resetExternalParameterSourceState",
    RESET_EXTERNAL_PARAMETER_CUSTOMER_STATE: "resetExternalParameterCustomerState",
    RESET_IS_EXTERNAL_PARAMETER: "resetIsExternalParameter",

    //Affiliate Cookies
    UPDATE_AFFILIATE_COOKIES: "updateAffiliateCookies",
};

export { storeMutations };
